/* ======================================================================== */
/* 36. SmoothScroll */
/* ======================================================================== */
var SmoothScroll = function () {

	var
		$smoothScroll = $('.js-smooth-scroll'),
		$WPadminBar = $('#wpadminbar');

	if (!$smoothScroll.length) {
		return;
	}

	// don't launch in Elementor edit mode
	if (typeof elementor != 'undefined') {
		return;
	}

	// don't launch on mobiles
	if (Modernizr.touchevents && !$smoothScroll.hasClass('js-smooth-scroll_enable-mobile')) {
		return;
	}

	$smoothScroll.addClass('smooth-scroll');

	if (window.theme.smoothScroll.plugins.edgeEasing) {
		Scrollbar.use(window.EdgeEasingPlugin);
	}

	window.SB = Scrollbar.init($smoothScroll[0], window.theme.smoothScroll);

	// Compatability with Waypoints plugin
	if (window.SB !== undefined && typeof Waypoint == 'function') {

		window.SB.addListener(function () {
			Waypoint.refreshAll();
		});

	}

	// prevent double scroll because of the offset created
	// by WordPress.menu-overlay .sub-menu admin bar
	if (window.SB !== undefined && $WPadminBar.length) {

		window.$html.css({
			overflow: 'hidden'
		});

	}

}
